
<template>
<div>
  <div class="flex task_item" :class="[state=='3'?'itemdark':'']" @click="goDetail(item)"  >
    <div class="f18 c3 text">{{item.TA_Name}}</div>
    <div class="f14 c9 date" v-if="item.TA_TimeType == 0">任务时间：15天内</div>
    <div class="f14 c9 date" v-if="item.TA_TimeType == 1">任务时间：{{ $conFun.parseData(item.TA_BTime) }} 至{{ $conFun.parseData(item.TA_ETime) }}</div>
    <div class="f14 c9 date" v-if="item.TA_TimeType == 2">任务时间： 不限时</div>
    <div class="f14 c9 progess">完成度：{{ item.done }}/{{ item.allNum }}</div>
    <div><img :src="getState()" /></div>        
  </div>
</div>
</template>
<script>
export default {
     props:{        
        item:'' ,
        tabNum:''      
      },
  data() {     
    return {
      isShow:null,
      images: [require('@/assets/images/task/weikshi.png'), require('@/assets/images/task/jinxingzhong.png'), require('@/assets/images/task/yiwancheng.png'), require('@/assets/images/task/yiyuqi.png')],
			state: '0'//0未开始，1进行中，2已完成，3已逾期{{tabNum}}--{{state}}--{{isShow}}:style="{display:(isShow?'':'none')}" 
    }
  },
  methods: {   
		getState() {
			if (this.item.done == this.item.allNum) {
				this.state = '2';
			} else if (this.item.TA_TimeType == 2) {
				this.state = '1';
			} else {
				var c = new Date().getTime();
				var start = this.item.TA_BTime;
				var end = this.item.TA_ETime;
				if ((start + '').length < 13) {
					var ssss = 1;
					for (var i = (start + '').length; i < 13; i++) {
						ssss *= 10;
					}
					start *= ssss;
				}
				if ((end + '').length < 13) {
					var eeee = 1;
					for (var i = (end + '').length; i < 13; i++) {
						eeee *= 10;
					}
					end *= eeee;
				}
				if (c < start) {
					this.state = '0';
				} else if (c < end) {
					this.state = '1';
				} else {
					this.state = '3';
				}
			}
      // if(this.tabNum == 'allNum'){
      //     this.isShow = true
      // }
      // if(this.tabNum == 'unover'){
      //    if(this.state =='0' || this.state =='1'){
      //      this.isShow = true
      //    } 
      // }
      // if(this.tabNum == 'done'){
      //     if(this.state =='2' ){
      //      this.isShow = true
      //    } 
      // }
     
			return this.images[this.state];
		},
		goDetail(item) {
      if(this.state =='3'){
        return
      }else if(this.state =='0'){
         this.$message({
              message: '任务未开始',
              type: 'warning'
         });
      }else{
        var that = this;
		    this.$router.push({ path: this.redirect || "/Task/Detail?taskId=" + item.TA_ID +'&state='+this.state +'&title='+item.TA_Name})  
      }
			    
		}
  }
}
</script>
<style>
.task_item{
    height: 98px;
    background: #ffffff;
    border: 1px solid #f3f4f7;
    z-index:1;
    position:relative;
    padding:0 33px;
   
}

.task_item:hover{
    box-shadow: 0px 1px 10px 0px rgba(0,0,0,0.15);
    z-index:2;
    cursor: pointer;
}
.task_item:hover .text{
    color:#4B9AFB
}
.task_item .text{
   width:320px;
   margin-right:100px
}
.task_item .date{
  width:320px
}
.task_item .progess{
  margin:0 100px
}
.task_list .itemdark div{
  color:#ccc
}
.task_list .itemdark:hover{
   box-shadow:none;
   cursor: no-drop;
}
.task_list .itemdark:hover .text{
   color:#ccc
}
</style>


// WEBPACK FOOTER //
// src/views/Task/components/TaskItem.vue